//
// Login:
//

export const index = {
    path   : '/recruits/',
    method : 'GET',
    version: '/v1'
}

export const getItem = {
  path   : '/recruits/:recruit_id/',
  method : 'GET',
  version: '/v1'
}

export const addItem = {
  path   : '/recruits/',
  method : 'POST',
  version: '/v1'
}

export const updateItem = {
  path   : '/recruits/:recruit_id/',
  method : 'POST',
  version: '/v1'
}

export const deleteItem = {
  path   : '/recruits/:recruit_id/',
  method : 'DELETE',
  version: '/v1'
}
